export const formatPercent = (number, { signed = false } = {}) => {
  if (typeof number !== "number" || isNaN(number)) {
    return number;
  }

  const percent = (number * 100).toFixed(3);

  if (signed && number > 0) return `+${percent}%`;
  return `${percent}%`;
};
